module.exports = __webpack_public_path__ + "img/unload.a8ba0fe9.svg";